<template>
  <div class="text-center p-4 border-bottom">
    <div class="mb-4 profile-user">
      <img
        :onerror="`this.src = '${require('@/static/user__1_.png')}'`"
        :src="profileAvatarImage"
        class="rounded-circle avatar-lg img-thumbnail"
        alt
      >
      <button
        type="button"
        class="btn bg-light avatar-xs p-0 rounded-circle profile-photo-edit"
        @click="showChangeProfile = true"
      >
        <i class="ri-pencil-fill" />
      </button>
    </div>
    <h5 class="font-size-16 mb-1 text-truncate">
      {{ profileName }}
    </h5>

    <form-change-profile :show.sync="showChangeProfile" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FormChangeProfile from "./Form/ChangeProfileFormProfileTabComponents";
import {fullName} from "../../../utils/contactName";

export default {
  components: {
    FormChangeProfile,
  },
  data: () => ({
    showChangeProfile: false,
  }),
  computed: {
    ...mapGetters('auth', ['user']),
    profileAvatarImage() {
      return this.user.avatar_image_url || require('@/static/user__1_.png');
    },
    profileName() {
      return fullName(this.user);
    },
  },
}
</script>

<style scoped>

</style>
